export default "__VITE_ASSET__D1LwJ96Z__"